<ng-template #tabsContent>
  <div class="add-post__tabs">
    <button
      class="add-post__tab"
      [class.active]="activeTab() === 'post'"
      (click)="selectTab('post')"
    >
      <div class="add-post__tab-inner">
        <span class="add-post__tab-title">Post</span>
        <div class="add-post__tab-indicator"></div>
      </div>
    </button>
    <button
      class="add-post__tab"
      [class.active]="activeTab() === 'video'"
      (click)="selectTab('video')"
    >
      <div class="add-post__tab-inner">
        <span class="add-post__tab-title">Video</span>
        <div class="add-post__tab-indicator"></div>
      </div>
    </button>
  </div>

  @if (activeTab() === 'post') {
    <outlaw-post-tab [form]="postForm" (publishRequested)="publish()" />
  }

  @if (activeTab() === 'video') {
    <outlaw-video-tab [form]="videoForm" (publishRequested)="publish()" />
  }
</ng-template>

@if (isMobile()) {
  <div class="add-post add-post--mobile">
    <div class="add-post__mobile-header">
      <button class="add-post__back-btn" (click)="close()">
        <outlaw-icon name="arrowLeft" [size]="24" />
      </button>
      <div class="add-post__mobile-header-right">
        <outlaw-selections-menu
          [selections]="state.allSelections()"
          postUuid="__pending__"
          mode="inline"
          (selectionToggled)="state.toggleSelection($event)"
          (createClicked)="state.openCreateSelection()"
        >
          <button
            class="add-post__selections-btn"
            [class.active]="state.selectedSelections().length > 0"
          >
            <outlaw-icon name="grid" [size]="26" />
          </button>
        </outlaw-selections-menu>
        <button
          class="add-post__publish-btn"
          [disabled]="!canPublish()"
          (click)="publish()"
        >
          Publish
        </button>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="tabsContent" />
  </div>
} @else {
  <outlaw-dialog-wrapper>
    <div class="add-post">
      <ng-container *ngTemplateOutlet="tabsContent" />
    </div>
  </outlaw-dialog-wrapper>
}
